<template>
    <div class="container">
        <triangle-image title="Lo chef sei tu. La cena la regala LiveFAST" />
        <div >
            <div class="content">

                <section>
                    <h5 class="text">
                        La promozione <img src="../assets/img/fastweb.png" alt="LiveFast" width="140px" style="vertical-align: text-top;"> 2018 è terminata ma non preoccuparti! Ogni settimana proponiamo nuove ricette che puoi ricevere comodamente a casa tua. Ti aspettiamo su Quomi!
                    </h5>
                </section>

                <section>
                    <h2 class="center">{{ $t("components.plans.recipes_title") }}</h2>
                </section>

                <section>
                    <opinions :template="'plans'" />
                </section>

                <section>
                    <faq />
                </section>

            </div>

            <start-with-us />

        </div>

    </div>
</template>

<script>

import StartWithUs from './Parts/StartWithUs'
import TriangleImage from './TriangleImage'

import Faq from './Faq'
import Opinions from './Opinions'

export default {
	components: {
		'opinions': Opinions,
		'faq': Faq,
		'start-with-us': StartWithUs,
		'triangle-image': TriangleImage
	}
}

</script>

<style scoped>
    .container {
        padding-top: 40px;
    }

    section {
        padding: 0 0 30px 0;
    }

    h5 {
        text-align: center;
        vertical-align: middle;
        line-height: 1.5;
    }

    .triangle-image {
        background-image: url("../assets/img/covers/fastweb.jpg");
        background-position: 50% 60px;
    }

</style>
